export default __webpack_public_path__ + "static/media/SourceSansPro-LightItalic.5959ce01.ttf";